import classNames from 'classnames';
import React, { FunctionComponent } from 'react';
import {
    DEFAULT_STYLES,
    getStyles,
    REBRANDING_STYLES,
} from '../../../utils/rebrand';
import { TicketContentProps, TicketFeeTaxDescription } from '../TicketContent';
import defaultStyles from './TicketDonationFeeTaxDescription.module.scss';
import rebrandStyles from './TicketDonationFeeTaxDescription.rebranding.module.scss';

const stylesModules = {
    [DEFAULT_STYLES]: defaultStyles,
    [REBRANDING_STYLES]: rebrandStyles,
};
export interface TicketDonationFeeTaxDescriptionProps
    extends Pick<TicketContentProps, 'category' | 'includeFee' | 'includeTax'> {
    canBeSelected: boolean;
    isAppRebrandActive?: boolean;
    separatorCharacter: string;
}

export const TicketDonationFeeTaxDescription: FunctionComponent<
    TicketDonationFeeTaxDescriptionProps
> = ({
    canBeSelected,
    category,
    includeFee,
    includeTax,
    isAppRebrandActive = false,
    separatorCharacter,
}) => {
    const donationText = TicketFeeTaxDescription({
        canBeSelected,
        category,
        includeFee,
        includeTax,
    });

    if (donationText === null) return null;

    const theme = getStyles(isAppRebrandActive);
    const styles = stylesModules[theme];

    return (
        <span
            className={classNames(styles.default, {
                'eds-text-color--ui-800': !isAppRebrandActive,
            })}
            data-testid="ticket-donation-fee-tax-description"
        >
            {separatorCharacter}
            {donationText}
        </span>
    );
};
export default TicketDonationFeeTaxDescription;
